 
type ChangeHandler = (newValue: string) => void;

interface TextFieldProps {
  id: string;
  label: string;
  type?: "text" | "password";
  value: string;
  onChange: ChangeHandler;
  error?: string;
  helperText?: string;
  autoComplete?: string;
  required?: boolean;
  "data-testid"?: string;
}

export function TextField({
  id,
  label,
  type = "text",
  value,
  onChange,
  error,
  helperText,
  autoComplete,
  required,
  "data-testid": testId,
}: TextFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label
        htmlFor={id}
        className="text-sm font-semibold text-on-surface"
      >
        {label}
      </label>
      <input
        id={id}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete={autoComplete}
        required={required}
        data-testid={testId}
        className={`h-10 w-full bg-surface-raised border rounded-md ps-3 pe-3 text-base text-start focus-visible:ring-2 focus-visible:ring-primary focus-visible:border-transparent outline-none transition-colors duration-200 ${
          error ? "border-error" : "border-divider"
        }`}
      />
      {helperText && (
        <p className="text-sm text-text-secondary">{helperText}</p>
      )}
      {error && (
        <p className="text-sm text-error">{error}</p>
      )}
    </div>
  );
}
